import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

type CPProfileOptionsLocs =
	| 'CPProfileOptionsTitle'
	| 'CPProfileOptionsDescription'
	| 'CPProfileOptionsEmailPrefsSectionTitle'
	| 'CPProfileOptionsEmailPrefsDefaultLang'
	| 'CPProfileOptionsEmailPrefsRestrictEmails'
	| 'CPProfileOptionsEmailPrefsRestrictEmailsExplanation'
	| 'CPProfileOptionsEmailPrefsUpdateButton';

export const cpProfileOptionsLocs: LocDefs<CPProfileOptionsLocs> = {
	CPProfileOptionsTitle: {
		legacyName: 'CandidatePreferences/Profile.Options.Title.EmailPreferences',
		defaultValue: 'Options',
		description: 'Title for the candidate options section.',
		displayPath: 'Profile|Options|Page Title',
		displayType: 'Title',
		feature: HubFeature.CandidatePreferences,
		portal: 'CP',
		htmlAllowed: false,
		shared: false,
	},
	CPProfileOptionsDescription: {
		legacyName: 'CandidatePreferences/Profile.Options.Content.EmailPreferencesDescription',
		defaultValue: '',
		description: 'Description for the candidate options page.',
		displayPath: 'Profile|Options|Page Description',
		displayType: 'Content',
		feature: HubFeature.CandidatePreferences,
		portal: 'CP',
		htmlAllowed: true,
		shared: false,
	},
	CPProfileOptionsEmailPrefsSectionTitle: {
		legacyName: 'CandidatePreferences/Profile.Options.Title.EmailPreferences',
		defaultValue: 'Email Preferences',
		description: 'Title for the email preferences section.',
		displayPath: 'Profile|Options|Email Preferences Section Title',
		displayType: 'Title',
		feature: HubFeature.CandidatePreferences,
		portal: 'CP',
		htmlAllowed: false,
		shared: false,
	},
	CPProfileOptionsEmailPrefsDefaultLang: {
		legacyName:
			'CandidatePreferences.CandidateEmailLanguage/Profile.Options.FieldLabel.DefaultEmailLang',
		defaultValue: 'Default Email Language',
		description: 'Label for the default email language field.',
		displayPath: 'Profile|Options|Default Email Language',
		displayType: 'Label',
		feature: HubFeature.CandidatePreferencesCandidateEmailLanguage,
		portal: 'CP',
		htmlAllowed: false,
	},
	CPProfileOptionsEmailPrefsRestrictEmails: {
		legacyName: 'CandidatePreferences.DisableEmails/Profile.Options.FieldLabel.RestrictEmails',
		defaultValue: 'Restrict Emails',
		description: 'Label for the restrict emails field.',
		displayPath: 'Profile|Options|Restrict Emails',
		displayType: 'Label',
		feature: HubFeature.CandidatePreferencesDisableEmails,
		portal: 'CP',
		htmlAllowed: false,
		shared: false,
	},
	CPProfileOptionsEmailPrefsRestrictEmailsExplanation: {
		legacyName:
			'CandidatePreferences.DisableEmails/Profile.Options.Content.RestrictEmailsExplanation',
		defaultValue:
			'Select this check box if you want to opt-out of program related emails from this system. You will continue to receive operational emails that are critical to the function of this application. This may include but is not limited to, forgot password and email change notifications.',
		description: 'Explanation for the restrict emails field.',
		displayPath: 'Profile|Options|Restrict Emails Explanation',
		displayType: 'Content',
		feature: HubFeature.CandidatePreferencesDisableEmails,
		portal: 'CP',
		htmlAllowed: false,
		shared: false,
	},
	CPProfileOptionsEmailPrefsUpdateButton: {
		legacyName: 'CandidatePreferences/Profile.Options.Button.Update',
		defaultValue: 'Update Preferences',
		description: 'Button for the update preferences field.',
		displayPath: 'Profile|Options|Update Preferences',
		displayType: 'Button',
		feature: HubFeature.CandidatePreferences,
		portal: 'CP',
		htmlAllowed: false,
		shared: false,
	},
};

export const cpProfileOptionsLocKeys = MapLocKeys<CPProfileOptionsLocs>(cpProfileOptionsLocs);
export type CPProfileOptionsLocKeys = typeof cpProfileOptionsLocKeys;
